export const LOG_CSS_COLORS =
  'background: #008cf4; color: #ffffff; font-size: 12px; padding: 2px 4px;'
export const LOG_CSS_ERROR_COLORS =
  'background: #974855; color: #ffffff; font-size: 12px; padding: 2px 4px;'
export const DEFAULT_APP_BAR_HEIGHT = 88
export const DEFAULT_BREADCRUMBS_HEIGHT = 80
export const DEFAULT_PADDING = '24px'
export const DEFAULT_MARGIN = '24px'
export const DEFAULT_SNACKBAR_HEIGHT = '60'
export const DEFAULT_SNACKBAR_WIDTH = '100vw'
export const DEFAULT_DATETIME_PICKER_HEIGHT = 40
export const DEFAULT_FILTER_WIDTH = 200
export const AUTOCOMPLETE_DROPDOWN_HEIGHT = 526
export const TOAST_NOTIFICATION_ICONS = {
  success: 'mdi-check-circle',
  error: 'mdi-close-circle',
  info: 'mdi-information'
}
export const DEFAULT_TEAM_COLORS = [
  '#FF34BA',
  '#FB4A4A',
  '#28C6F8',
  '#00BF86',
  '#FF8E26',
  '#5D2AEF',
  '#287BF8',
  '#25D7A1',
  '#484848'
]

export const avatarColorPresets = [
  {
    group: 'ajs1',
    color: DEFAULT_TEAM_COLORS[0]
  },
  {
    group: 'bkt2',
    color: DEFAULT_TEAM_COLORS[1]
  },
  {
    group: 'clu3',
    color: DEFAULT_TEAM_COLORS[2]
  },
  {
    group: 'dmv4',
    color: DEFAULT_TEAM_COLORS[3]
  },
  {
    group: 'enw5',
    color: DEFAULT_TEAM_COLORS[4]
  },
  {
    group: 'fox6',
    color: DEFAULT_TEAM_COLORS[5]
  },
  {
    group: 'gpy7',
    color: DEFAULT_TEAM_COLORS[6]
  },
  {
    group: 'hqz8',
    color: DEFAULT_TEAM_COLORS[7]
  },
  {
    group: 'ir09',
    color: DEFAULT_TEAM_COLORS[8]
  }
]

export const avatarColors = DEFAULT_TEAM_COLORS
export const INVALID_LABEL_COLOR = '#ff0000'
export const UNAVAILABLE_LABEL = 'N/A'
export const DATE_TIME_FORMAT = 'DD MMM YYYY, hh:mm a'
export const DATE_TIME_FORMAT_12_HRS = 'DD MMM YYYY, hh:mm a'
export const DATE_TIME_FORMAT_24_HRS = 'DD MMM YYYY, HH:mm'
export const DATE_TIME_FORMAT_SCHEDULE_X = 'YYYY-MM-DD HH:mm'
export const DATE_TIME_FORMAT_CALENDAR = 'YYYY-MM-DD HH:mm'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY'
export const LIST_ITEM_DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_FORMAT_TIME_PICKER = 'YYYY-MM-DD'
export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const TIME_FORMAT_12_HRS = 'h:mm a'
export const TIME_FORMAT_24_HRS = 'HH:mm:ss'
export const NAVBAR_WIDTH = 280
export const COLLAPSED_NAVBAR_WIDTH = 72
export const DEFAULT_PROFILE_COLOR = '#10B981'
export const BUTTON_HEIGHTS = {
  xl: 56,
  lg: 40,
  md: 36,
  sm: 28
}
